import { useSelector } from "react-redux";
import { User } from "src/lib/slices/userSlice";
import useSWR from "swr";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";
import { transformImgSrc } from "../Image";

const fetcher = (token) => async (url) => {
  const res = await fetch(url, { headers: { Authorization: token } });

  return res.json();
};

export default function UsersList({
  userIds,
  maxPhotos = 3,
  showCount = true,
}: {
  userIds: string[];
  maxPhotos?: number;
  showCount?: boolean;
}) {
  const user: User = useSelector((state: any) => state.user);

  const { data } = useSWR<string[]>(
    `${
      process.env.REACT_APP_API_URL
    }/users/profile-pictures?userIds=${encodeURIComponent(
      userIds.slice(0, 25).join(",")
    )}`,
    fetcher(user.token)
  );

  const width = 1.5 + 0.6 * Math.min(userIds.length - 1, maxPhotos);

  return (
    <div className="flex flex-col items-center w-fit">
      <div className="flex" style={{ width: `${width}rem` }}>
        {userIds.slice(0, maxPhotos).map((userId, index) => (
          <Avatar
            style={{
              width: "1.5rem",
              height: "1.5rem",
              position: "relative",
              left: `${-index * 0.9}rem`,
              zIndex: `${maxPhotos - index}`,
              border: "0.1rem solid #ffffff10",
            }}
            key={userId}
          >
            {data && data[index] && (
              <AvatarImage
                src={transformImgSrc(data[index])}
                alt="Profilový obrázek"
              />
            )}
            <AvatarFallback>U</AvatarFallback>
          </Avatar>
        ))}
      </div>
      {showCount && <div>{userIds.length}</div>}
    </div>
  );
}
